/**
 * B080070出荷予定実績照会
 */
import { Column, Query } from "@material-table/core";
import { Box } from "@mui/material";
import {
  B000150TokuiNm2,
  B000151NonyuNm,
  B000200ByJanCdShohinNmr,
  B000200ShohinNm,
  B000223BatchNm,
  B000224HaisorouteNm,
  B080070ExcelRequest,
  B080070Find,
  B080070FindRequest,
  B080070GetExcel,
  catchFileError,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SCodeSelect,
  SDateField,
  SFileButton,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  SText,
  STextField,
} from "components";
import { getClientError, getClientMessage } from "messages";
import {
  b080070shukajokyou,
  getSCode,
  SCode,
  ShohinshubetsuKbn,
} from "messages/codes";
import { labels } from "messages/labels";
import { createRef, useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { date, download } from "services";
import { focusState, useFocus } from "states";
import { B000150 } from "../b000/B000150";
import { B000151 } from "../b000/B000151";
import { B000200 } from "../b000/B000200";
import { B000223 } from "../b000/B000223";
import { B000224 } from "../b000/B000224";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  shukashijiYmd: string;
  juchuYmd: string;
  nohinyoteiYmd: string;
  shukayoteiYmd: string;
  shijikaisu: string;
  batchNo: string;
  batchNm: string;
  haisorouteNo: string;
  haisorouteNm: string;
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
  nonyuCd: string;
  nonyushitenCd: string;
  nonyuNm: string;
  shohinCd: string;
  shohinNm: string;
  janCd: string;
  shohinNmr: string;
  juchudenpyoNo: string;
  shohinshubetsuKbn: SCode;
}>;

type Data = Partial<{
  haisorouteNoFormat: string;
  tokuiCdFormat: string;
  nonyuCdFormat: string;
  shohinCd: string;
  shukayoteisu: string;
  shukasu: string;
  gentanka: string;
  juchuYmd: string;
  nohinyoteiYmdFormat: string;
  shukayoteiYmdFormat: string;
  shukajokyo: string;
  suryoteisei: string;
  juchudenpyoNo: string;
  juchudenpyoNoF: string;
  shohinshubetsuKbnFormat: string;
  juchugyoNo: string;
  meisaibiko: string;
  ppshiji: string;
  netsukeshiji: string;
  setshohinCd: string;
  setshohinNm: string;
  sethingentanka: string;
  setgyobiko: string;
  shainNm: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  shukashijiYmd: date(),
  juchuYmd: "",
  nohinyoteiYmd: "",
  shukayoteiYmd: "",
  shijikaisu: "",
  batchNo: "",
  batchNm: "",
  haisorouteNo: "",
  haisorouteNm: "",
  tokuiCd: "",
  tokuishitenCd: "",
  tokuiNm: "",
  nonyuCd: "",
  nonyushitenCd: "",
  nonyuNm: "",
  shohinCd: "",
  shohinNm: "",
  janCd: "",
  shohinNmr: "",
  juchudenpyoNo: "",
  shohinshubetsuKbn: undefined,
};
// テーブルを定義する。
const columns: Column<Data>[] = [
  { field: "haisorouteNoFormat", title: "配送ルート番号", width: "7rem" },
  { field: "tokuiCdFormat", title: "得意先コード", width: "7rem" },
  { field: "nonyuCdFormat", title: "納入先コード", width: "7rem" },
  { field: "shohinCd", title: "商品コード", width: "7rem" },
  {
    field: "shukayoteisu",
    title: "予定数　",
    width: "4rem",
    align: "right",
    render: (data) => data.shukayoteisu?.toLocaleString(),
  },
  {
    field: "shukasu",
    title: "出荷数　",
    width: "4rem",
    align: "right",
    render: (data) => data.shukasu?.toLocaleString(),
  },
  {
    field: "gentanka",
    title: "単価　",
    width: "6rem",
    align: "right",
    render: (data) => data.gentanka?.toLocaleString(),
  },
  { field: "juchuYmdFormat", title: "受注日", width: "7rem" },
  { field: "nohinyoteiYmdFormat", title: "納品日", width: "7rem" },
  { field: "shukayoteiYmdFormat", title: "出荷日", width: "7rem" },
  {
    field: "shukajokyo",
    title: "出荷状況",
    width: "7rem",
    render: (data) => {
      let color = "";
      //出荷状況 未処理 赤
      if (data.shukajokyo === getSCode(b080070shukajokyou, "0")?.label) {
        color = "#FF0000";
        return <Box sx={{ color: color }}>{data.shukajokyo}</Box>;
      } else if (data.shukajokyo === getSCode(b080070shukajokyou, "1")?.label) {
        color = "#0000FF";
        return <Box sx={{ color: color }}>{data.shukajokyo}</Box>;
      } else if (data.shukajokyo === getSCode(b080070shukajokyou, "2")?.label) {
        color = "#008000";
        return <Box sx={{ color: color }}>{data.shukajokyo}</Box>;
      } else if (data.shukajokyo === getSCode(b080070shukajokyou, "9")?.label) {
        color = "#000000";
        return <Box sx={{ color: color }}>{data.shukajokyo}</Box>;
      }
    },
  },
  { field: "shukajokyo", hidden: true },
  { field: "suryoteisei", title: "数量訂正", width: "4rem" },
  { field: "juchudenpyoNoF", title: "受注番号", width: "7rem" },
  { field: "juchudenpyoNo", hidden: true },
  { field: "shohinshubetsuKbnFormat", title: "商品種別", width: "9rem" },
  {
    field: "juchugyoNo",
    title: "受注行　",
    width: "4rem",
    align: "right",
    render: (data) => data.juchugyoNo?.toLocaleString(),
  },
  { field: "meisaibiko", title: "伝票行備考", width: "15rem" },
  { field: "ppshiji", title: "PP", width: "3rem" },
  { field: "netsukeshiji", title: "値付", width: "3rem" },
  { field: "setshohinCd", title: "セット商品コード", width: "7rem" },
  { field: "setshohinNm", title: "セット商品名", width: "15rem" },
  {
    field: "sethingentanka",
    title: "セット後金額　",
    width: "8rem",
    align: "right",
    render: (data) => data.sethingentanka?.toLocaleString(),
  },
  { field: "setgyobiko", title: "セット行備考", width: "15rem" },
  { field: "shainNm", title: "受注担当者名", width: "15rem" },
];

const focusId = "B080070";

export const B080070 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};
const Page = (props: Props) => {
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // Excel出力ボタン活性制御
  const [disabledExcelButton, setDisabledExcelButton] = useState(true);
  //　フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // 画面遷移
  const navigate = useNavigate();

  //初期表示
  useEffect(() => {
    focus(1);
  });

  // 初回検索用のフラグ
  const [searched, setSearched] = useState(false);
  // 検索ボタン押下時に初期ページにするステート
  const isDefaultPage = useRef(false);
  // テーブルの値取得用Ref
  const tableRef = createRef(); //検索イベント

  //検索イベント
  const handleSearch = (query: Query<any>) =>
    new Promise<any>((resolve) => {
      // 初回検索をしない
      if (!searched) {
        resolve({
          data: [],
          page: 0,
          totalCount: 0,
        });
        return;
      }

      setMsg("");

      // 検索フォームのデータを取得する。
      const fields = methods.getValues();

      // 初期ページ表示の場合、0を設定する。
      query.page = isDefaultPage.current ? 0 : query.page;

      const param: B080070FindRequest = {
        shukashijiYmd: fields.shukashijiYmd!,
        juchuYmd: fields.juchuYmd,
        nohinyoteiYmd: fields.nohinyoteiYmd,
        shukayoteiYmd: fields.shukayoteiYmd,
        shijikaisu: fields.shijikaisu,
        batchNo: fields.batchNo,
        haisorouteNo: fields.haisorouteNo,
        tokuiCd: fields.tokuiCd,
        tokuishitenCd: fields.tokuishitenCd,
        nonyuCd: fields.nonyuCd,
        nonyushitenCd: fields.nonyushitenCd,
        shohinCd: fields.shohinCd,
        janCd: fields.janCd,
        juchudenpyoNo: fields.juchudenpyoNo,
        shohinshubetsuKbn: fields.shohinshubetsuKbn?.value,
        page: query.page,
        size: query.pageSize,
        sort: ["batchNo,asc"],
      };
      B080070Find(param)
        .then((value) => {
          console.log(value.data);
          if (value.data.totalElements === 0) {
            setDisabledExcelButton(true);
            setMsg(getClientError("B080070_001"));
          } else {
            setDisabledExcelButton(false);
          }
          value.data.content.map(
            (v: any, i: number) => (v.id = i + 1 + query.pageSize * query.page)
          );
          resolve({
            data: value.data.content,
            page: value.data.number,
            totalCount: value.data.totalElements,
          });
        })
        .catch((reason) => {
          setDisabledExcelButton(true);
          catchRestError(reason, navigate, setMsg);
          resolve({
            data: [],
            page: query.page,
            totalCount: 0,
          });
        })
        .finally(() => {
          // 初期ページ表示をオフにする。
          isDefaultPage.current = false;
        });
    });

  const handleClickSearchButton = () => {
    // 検索可能に変更
    setSearched(true);
    // 初期ページ設定
    isDefaultPage.current = true;
    // テーブル再検索
    (tableRef.current as any).onQueryChange();
  };

  //Excel出力ボタンクリックイベント
  const handleClickExcelButton = () => {
    // Excel出力力フォームのデータを取得する
    const fields = methods.getValues();
    //　Excel出力パラメータを作成する
    const params: B080070ExcelRequest = {
      shukashijiYmd: fields.shukashijiYmd!,
      juchuYmd: fields.juchuYmd,
      nohinyoteiYmd: fields.nohinyoteiYmd,
      shukayoteiYmd: fields.shukayoteiYmd,
      shijikaisu: fields.shijikaisu,
      batchNo: fields.batchNo,
      haisorouteNo: fields.haisorouteNo,
      tokuiCd: fields.tokuiCd,
      tokuishitenCd: fields.tokuishitenCd,
      nonyuCd: fields.nonyuCd,
      nonyushitenCd: fields.nonyushitenCd,
      shohinCd: fields.shohinCd,
      janCd: fields.janCd,
      juchudenpyoNo: fields.juchudenpyoNo,
      shohinshubetsuKbn: fields.shohinshubetsuKbn?.value,
    };
    B080070GetExcel(params)
      .then((response) => {
        download(response);
        setMsg(getClientMessage("B080070_001"));
      })
      .catch((reason) => {
        catchFileError(reason, navigate, setMsg);
      });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="出荷予定実績照会"
        gridTemplateColumns="6rem 6rem 5rem 18rem 7rem 6rem 5rem 20rem"
      >
        <SLabel required>出荷指示日</SLabel>
        <SDateField
          name="shukashijiYmd"
          label="出荷指示日"
          required
          gridColumn="span 2"
          {...register(1)}
        />
        <SLabel gridColumn={5}>受注日</SLabel>
        <SDateField name="juchuYmd" gridColumn="span 2" {...register(2)} />
        <SLabel gridColumn="1">納品日</SLabel>
        <SDateField name="nohinyoteiYmd" gridColumn="span 2" {...register(3)} />
        <SLabel gridColumn={5}>出荷日</SLabel>
        <SDateField name="shukayoteiYmd" gridColumn="span 2" {...register(4)} />
        <SText gridColumn="1"></SText>
        <SLabel gridColumn="1">指示回数</SLabel>
        <SNumberField
          name="shijikaisu"
          code
          size={4}
          {...register(5)}
          gridColumn="span 2"
        />
        <SLabel gridColumn={5}>バッチ番号</SLabel>
        <SNumberField
          name="batchNo"
          code
          size={4}
          {...register(6)}
          gridColumn="span 2"
          dialog={<B000223 />}
          onBlur={() => B000223BatchNm(methods, navigate, setMsg)}
          handleSubmit={(data: any) => {
            methods.setValue("batchNo", data.batchNo);
            methods.setValue("batchNm", data.batchNm);
          }}
        />
        <STextField name="batchNm" size={40} disabled />
        <SLabel gridColumn={5}>配送ルート番号</SLabel>
        <SNumberField
          name="haisorouteNo"
          code
          size={9}
          {...register(7)}
          gridColumn="span 2"
          dialog={<B000224 />}
          onBlur={() => B000224HaisorouteNm(methods, navigate, setMsg)}
          handleSubmit={(data: any) => {
            methods.setValue("haisorouteNo", data.haisorouteNo);
            methods.setValue("haisorouteNm", data.haisorouteNm);
          }}
        />
        <STextField name="haisorouteNm" size={40} disabled />
        <SText gridColumn="1"></SText>
        <SLabel gridColumn="1">得意先コード</SLabel>
        <SNumberField name="tokuiCd" code size={6} {...register(8)} />
        <SNumberField
          name="tokuishitenCd"
          code
          size={4}
          {...register(9)}
          dialog={<B000150 />}
          onBlur={() => B000150TokuiNm2(methods, navigate, setMsg)}
          handleSubmit={(data: any) => {
            methods.setValue("tokuiCd", data.tokuiCd);
            methods.setValue("tokuishitenCd", data.tokuishitenCd);
            methods.setValue("tokuiNm", data.tokuiNmr);
          }}
        />
        <STextField name="tokuiNm" size={20} disabled />
        <SLabel gridColumn={5}>納入先コード</SLabel>
        <SNumberField name="nonyuCd" code size={6} {...register(10)} />
        <SNumberField
          name="nonyushitenCd"
          code
          size={4}
          {...register(11)}
          onBlur={() => B000151NonyuNm(methods, navigate, setMsg)}
          dialog={<B000151 />}
          handleSubmit={(data: any) => {
            methods.setValue("nonyuCd", data.nonyuCd);
            methods.setValue("nonyushitenCd", data.nonyushitenCd);
            methods.setValue("nonyuNm", data.tokuiNmr);
          }}
        />
        <STextField name="nonyuNm" size={40} disabled />
        <SText gridColumn="1"></SText>
        <SLabel gridColumn="1">商品コード</SLabel>
        <SNumberField
          name="shohinCd"
          code
          size={10}
          {...register(12)}
          gridColumn="span 2"
          dialog={<B000200 />}
          onBlur={() => B000200ShohinNm(methods, navigate, setMsg)}
          handleSubmit={(data: any) => {
            methods.setValue("shohinCd", data.shohinCd);
            methods.setValue("shohinNm", data.shohinNmr);
          }}
        />
        <STextField name="shohinNm" disabled />
        <SLabel gridColumn={5}>JANコード</SLabel>
        <SNumberField
          name="janCd"
          code
          size={13}
          {...register(13)}
          gridColumn="span 2"
          onBlur={() => B000200ByJanCdShohinNmr(methods, navigate, setMsg)}
          dialog={<B000200 />}
          handleSubmit={(data: any) => {
            methods.setValue("janCd", data.janCd);
            methods.setValue("shohinNmr", data.shohinNmr);
          }}
        />
        <STextField name="shohinNmr" disabled />
        <SText gridColumn="1"></SText>
        <SLabel gridColumn="1">受注番号</SLabel>
        <SNumberField
          name="juchudenpyoNo"
          code
          size={10}
          {...register(15)}
          gridColumn="span 2"
        />
        <SLabel gridColumn="1">商品種別</SLabel>
        <SCodeSelect
          name="shohinshubetsuKbn"
          options={ShohinshubetsuKbn}
          empty
          {...register(15)}
          gridColumn="span 2"
        />
        <SNormalButton
          label={labels.buttons.search}
          gridRow={14}
          gridColumn={8}
          align="right"
          {...register(16)}
          onClick={handleClickSearchButton}
        />
      </SFrame>
      <SFrame gridTemplateColumns="73rem 6rem">
        <STable
          data={handleSearch}
          columns={columns}
          tableRef={tableRef}
          width={1265}
          height={340}
          handleSetDisabled={(rowData) =>
            rowData.shukajokyo === getSCode(b080070shukajokyou, "1")?.label ||
            rowData.shukajokyo === getSCode(b080070shukajokyou, "9")?.label
          }
        />
      </SFrame>
      <SFrame>
        <SFileButton
          label={labels.buttons.excel}
          disabled={disabledExcelButton}
          align="right"
          {...register(7)}
          onClick={handleClickExcelButton}
        />
      </SFrame>
    </FormProvider>
  );
};
